import createAxiosInstance from '../../../../api';
import { useDispatch } from 'react-redux';
import { setAllRoleListAction } from '../../../../stores/actionTypes/roleActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const dispatch = useDispatch();

  const fetchGetAllRoleList = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/listRole', payload)
      .then((response) => {
        dispatch(setAllRoleListAction(response?.data?.data));
        // data = response.data?.data;
      })
      .catch(() => {
        dispatch(setAllRoleListAction([]));
      });
    // return data;
  };

  return {
    fetchGetAllRoleList,
  };
}
